import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useOnboarding } from '../../contexts/onboarding-context';
import { useAuth } from '../../contexts/auth/auth-context';
import { Onboarding } from './onboarding';
import { OnboardingReady } from './ready/ready';
import { OnboardingReview } from './review/review';

const OnboardingContent: React.FC = () => {
  const { hasQuestions, totalQuestions, onboardingBootLoading } = useOnboarding();

  if (onboardingBootLoading) {
    return (
      <div style={{ background: '#1A1A1C', height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 32, height: 32, border: '3px solid rgba(255,255,255,0.15)', borderTopColor: '#5E84ED', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  const reallyHasQuestions = (totalQuestions ?? 0) > 0 || hasQuestions;

  if (reallyHasQuestions) {
    return <OnboardingReady />;
  }

  return <Onboarding />;
};

const OnboardingReviewWrapper: React.FC = () => {
  const { isCompleted } = useOnboarding();
  if (!isCompleted) return <Navigate to="/onboarding" replace />;
  return <OnboardingReview />;
};

const OnboardingGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { profile } = useAuth();
  const onboardingCompleted = profile?.onboarding_completed === true;

  // Only redirect if profile shows onboarding is completed
  // (profile is updated after user clicks Done and navigates)
  if (onboardingCompleted) {
    return <Navigate to="/chat" replace />;
  }

  return <>{children}</>;
};

export const OnboardingRouter: React.FC = () => {
  return (
    <OnboardingGate>
      <Routes>
        <Route path="/review" element={<OnboardingReviewWrapper />} />
        <Route path="/*" element={<OnboardingContent />} />
      </Routes>
    </OnboardingGate>
  );
};
